const addButtons = document.querySelectorAll('.cartAddBtn');
addButtons.forEach(item => {
  item.addEventListener('click', () => {
    const variantId = item.getAttribute('data-variant-id');
    cartAdd(variantId);
  });
});

// モーダル表示・非表示
const cartModal = document.querySelector('.item-list__modal');
const modalTriggers = document.querySelectorAll(
  '.modalOpen, .item-list__close, .item-list__overlay'
);
const body = document.querySelector('body');

modalTriggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    if (cartModal.classList.contains('is-show')) {
      // モーダルを非表示にする場合
      cartModal.animate([{ opacity: '1' }, { opacity: '0' }], {
        duration: 500,
        easing: 'ease-in-out',
        fill: 'forwards',
      }).onfinish = () => {
        cartModal.style.display = 'none';
        cartModal.classList.toggle('is-show');
        body.classList.toggle('body-fixed');
      };
    } else {
      // モーダルを表示する場合
      cartModal.style.opacity = 0;
      cartModal.style.display = 'block';
      cartModal.classList.toggle('is-show');
      body.classList.toggle('body-fixed');
      cartModal.animate([{ opacity: '0' }, { opacity: '1' }], {
        duration: 500,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    }
  });
});

const cartAdd = async variantId => {
  if (staffVariants.length !== 0) {
    for (const variant of staffVariants) {
      if (variant.id === variantId) {
        await staffStart.cart.sendTrackingRequest('31f09bbd4348f68171ed0248116906cd', {
          product_code: variant.sku,
          count: '1',
        });
      }
    }
  }

  // カートの現在の状態を取得
  const cart = await fetch('/cart.js').then(res => res.json());

  let variantExistsInCart = false;

  // カート内の商品を確認し、すでにカートに存在すれば数量を追加
  for (const item of cart.items) {
    if (item.id === Number(variantId)) {
      variantExistsInCart = true;
      const updatedQuantity = item.quantity + 1;

      // カートのアイテム数量を更新
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: { [variantId]: updatedQuantity } }),
      })
        .then(res => {
          if (res.ok) {
            window.location = '/cart';
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });

      break;
    }
  }

  // 商品がカート内に存在しない場合、新しいアイテムとして追加
  if (!variantExistsInCart) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        dataType: 'json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          },
        ],
      }),
    })
      .then(res => {
        if (res.ok) {
          window.location = '/cart';
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const parentItems = document.querySelectorAll('.productDetail__product__item:not(.heading)');
  const parentItemsSp = document.querySelectorAll('.item-list__item');

  // PCのカート追加セクションのサイズ並び順を変更
  parentItems.forEach((parentItem, index) => {
    let templateString = '';
    const items = Array.from(parentItem.querySelectorAll('.productDetail__button__stock__item'));

    items
      .sort((a, b) => {
        const aValue = a.dataset.order ? Number(a.dataset.order) : 999999;
        const bValue = b.dataset.order ? Number(b.dataset.order) : 999999;
        return aValue - bValue;
      })
      .forEach(item => (templateString += item.outerHTML));

    const list = parentItem.querySelector('.productDetail__button__stock__list');
    list.innerHTML = templateString;
  });

  // PCのカート追加モーダルのサイズ並び順を変更
  parentItemsSp.forEach((parentItem, index) => {
    let templateString = '';
    const items = Array.from(parentItem.querySelectorAll('.item-list__size'));

    items
      .sort((a, b) => {
        const aValue = a.dataset.order ? Number(a.dataset.order) : 999999;
        const bValue = b.dataset.order ? Number(b.dataset.order) : 999999;
        return aValue - bValue;
      })
      .forEach(item => (templateString += item.outerHTML));

    const list = parentItem.querySelector('.item-list__sizes');
    list.innerHTML = templateString;
  });

  // カートに追加処理を再度付与
  const addButtonsReloaded = document.querySelectorAll('.cartAddBtn');
  addButtonsReloaded.forEach(item => {
    item.addEventListener('click', () => {
      const variantId = item.getAttribute('data-variant-id');
      cartAdd(variantId);
    });
  });

});
